module.exports = __webpack_public_path__ + "img/map-pinpoint.cdfa8a95.png";